export default __webpack_public_path__ + "static/metamask-02e3ec2750d2107176f563de00a4c71f.png";